import { AxiosError } from 'axios';
import { ActionType, createAsyncAction } from 'typesafe-actions';
import {
  DronListData,
  GroupListData,
  StcsAreaData,
  StcsDayData
} from '../models/mainDashModel';

const STCS_DAY_REQUEST = 'main/dash/STCS_DAY_REQUEST';
const STCS_DAY_SUCCESS = 'main/dash/STCS_DAY_SUCCESS';
const STCS_DAY_FAILURE = 'main/dash/STCS_DAY_FAILURE';

const STCS_AREA_REQUEST = 'main/dash/STCS_AREA_REQUEST';
const STCS_AREA_SUCCESS = 'main/dash/STCS_AREA_SUCCESS';
const STCS_AREA_FAILURE = 'main/dash/STCS_AREA_FAILURE';

const GROUP_LIST_REQUEST = 'main/dash/GROUP_LIST_REQUEST';
const GROUP_LIST_SUCCESS = 'main/dash/GROUP_LIST_SUCCESS';
const GROUP_LIST_FAILURE = 'main/dash/GROUP_LIST_FAILURE';

const DRON_LIST_REQUEST = 'main/dash/DRON_LIST_REQUEST';
const DRON_LIST_SUCCESS = 'main/dash/DRON_LIST_SUCCESS';
const DRON_LIST_FAILURE = 'main/dash/DRON_LIST_FAILURE';

export const STCS_DAY = createAsyncAction(
  STCS_DAY_REQUEST,
  STCS_DAY_SUCCESS,
  STCS_DAY_FAILURE
)<string, { data: StcsDayData[] }, AxiosError>();

export const STCS_AREA = createAsyncAction(
  STCS_AREA_REQUEST,
  STCS_AREA_SUCCESS,
  STCS_AREA_FAILURE
)<string, { data: StcsAreaData[] }, AxiosError>();

export const GROUP_LIST = createAsyncAction(
  GROUP_LIST_REQUEST,
  GROUP_LIST_SUCCESS,
  GROUP_LIST_FAILURE
)<number, { data: GroupListData[] }, AxiosError>();

export const DRON_LIST = createAsyncAction(
  DRON_LIST_REQUEST,
  DRON_LIST_SUCCESS,
  DRON_LIST_FAILURE
)<number, { data: DronListData[] }, AxiosError>();

const actions = {
  STCS_DAY,
  STCS_AREA,
  GROUP_LIST,
  DRON_LIST
};

export type MainDashAction = ActionType<typeof actions>;
